// extracted by mini-css-extract-plugin
export default {"container":"chip-input_container__UTCF1","error-message":"chip-input_error-message__2lr6l","chips-wrapper":"chip-input_chips-wrapper__-tI+D"};